export const EXPERTISE_CACHE_NAME = 'employee-expertise';

export const enum ExpertiseLevel {
  BASIC = 'BASIC',
  CONFIDENT = 'CONFIDENT',
  EXPERT = 'EXPERT',
}

export const enum ExpertiseStatus {
  CONFIRMED = 'CONFIRMED',
  NON_CONFIRMED = 'NON_CONFIRMED',
}

export const enum ExpertiseType {
  COMMERCIAL = 'COMMERCIAL',
  NON_COMMERCIAL = 'NON_COMMERCIAL',
}

export const enum ExpertiseExperienceDuration {
  LESS_THAN_YEAR = 'LESS_THAN_YEAR',
  MORE_THAN_YEAR_LESS_THAN_THREE = 'MORE_THAN_YEAR_LESS_THAN_THREE',
  MORE_THAN_THREE_YEARS_LESS_THAN_FIVE_YEARS = 'MORE_THAN_THREE_YEARS_LESS_THAN_FIVE_YEARS',
  MORE_THAN_FIVE_YEARS = 'MORE_THAN_FIVE_YEARS',
}

export const ExpertiseExperienceDurationLabels = {
  [ExpertiseExperienceDuration.LESS_THAN_YEAR]: 'Less than a year',
  [ExpertiseExperienceDuration.MORE_THAN_YEAR_LESS_THAN_THREE]: 'More than a year, less than 3 years',
  [ExpertiseExperienceDuration.MORE_THAN_THREE_YEARS_LESS_THAN_FIVE_YEARS]: 'More than 3 years, less than 5 years',
  [ExpertiseExperienceDuration.MORE_THAN_FIVE_YEARS]: 'More than 5 years',
};

export const ExpertiseExperienceDurationShortLabels = {
  [ExpertiseExperienceDuration.LESS_THAN_YEAR]: '< 1 year',
  [ExpertiseExperienceDuration.MORE_THAN_YEAR_LESS_THAN_THREE]: '1-3 years',
  [ExpertiseExperienceDuration.MORE_THAN_THREE_YEARS_LESS_THAN_FIVE_YEARS]: '3-5 years',
  [ExpertiseExperienceDuration.MORE_THAN_FIVE_YEARS]: '> 5 years',
};

export const ExpertiseExperienceTypeLabels = {
  [ExpertiseType.COMMERCIAL]: 'Commercial',
  [ExpertiseType.NON_COMMERCIAL]: 'Non-commercial',
};

export const ExpertiseLevelLabels = {
  [ExpertiseLevel.BASIC]: 'Basic',
  [ExpertiseLevel.CONFIDENT]: 'Confident',
  [ExpertiseLevel.EXPERT]: 'Expert',
};

export const enum ExpertisePermission {
  PEOPLE_MANAGEMENT_EMPLOYEE_EXPERTISE_ASSIGN = 'PEOPLE_MANAGEMENT_EMPLOYEE_EXPERTISE_ASSIGN',
  PEOPLE_MANAGEMENT_EMPLOYEE_EXPERTISE_UPDATE = 'PEOPLE_MANAGEMENT_EMPLOYEE_EXPERTISE_UPDATE',
  PEOPLE_MANAGEMENT_EMPLOYEE_EXPERTISE_CONFIRM = 'PEOPLE_MANAGEMENT_EMPLOYEE_EXPERTISE_CONFIRM',
  PEOPLE_MANAGEMENT_EMPLOYEE_EXPERTISE_GET = 'PEOPLE_MANAGEMENT_EMPLOYEE_EXPERTISE_GET',
  PEOPLE_MANAGEMENT_EMPLOYEE_EXPERTISE_DELETE = 'PEOPLE_MANAGEMENT_EMPLOYEE_EXPERTISE_DELETE',
  PEOPLE_MANAGEMENT_EXPERTISE_DEFINITION_LIST_SEARCH = 'PEOPLE_MANAGEMENT_EXPERTISE_DEFINITION_LIST_SEARCH',
  PEOPLE_MANAGEMENT_EXPERTISE_DEFINITION_CREATE = 'PEOPLE_MANAGEMENT_EXPERTISE_DEFINITION_CREATE',
}

export const enum ExpertiseSuccessMessage {
  ADD = 'You are awesome! The expertise has been successfully added.',
  UPDATE = 'You are awesome! The expertise has been successfully updated.',
  DELETE = 'You are awesome! The expertise has been successfully deleted.',
  CREATE = 'You are awesome! The expertise has been successfully created.',
}

export const enum ExpertiseErrorMessage {
  REQUEST = 'Failed to request expertise.',
  SEARCH = 'Failed to search expertise.',
  ADD = 'Failed to add expertise.',
  UPDATE = 'Failed to update expertise.',
  DELETE = 'Failed to delete expertise.',
  CREATE = 'Failed to create expertise.',
}
